var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVruddhiVIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "320 100 200 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 400.97,
    y1: 145.15,
    x2: 400.97,
    y2: 275.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0073a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005487"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 399.53,
    y1: 145.15,
    x2: 399.53,
    y2: 275.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 458.99,
    y1: 145.15,
    x2: 458.99,
    y2: 275.54,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M425.25,148.63l-1.51-12.08c-.15-1.24-1.49-1.95-2.6-1.4l-10.89,5.43-10.05,5.01c-1.32,.66-1.34,2.52-.05,3.22l4.42,2.37-28.95,53.05c-.44,.81-.45,1.79-.02,2.6l6.51,12.36c1.03,1.95,3.81,1.96,4.86,.03l32.57-60.03,4.45,2.39c1.29,.69,2.83-.36,2.65-1.82l-1.39-11.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M465.86,134.02l-1.72-12.05c-.18-1.24-1.52-1.93-2.63-1.35l-10.8,5.62-9.96,5.18c-1.3,.68-1.3,2.54,0,3.22l4.15,2.13-57.6,109.71c-1.07,2.03-3.98,2.04-5.05,0l-33.16-63.19c-.49-.94-1.47-1.52-2.52-1.52h-12.12c-2.15,0-3.53,2.28-2.53,4.18l43.74,84.18,6.63,12.59c1.07,2.03,3.96,2.04,5.04,.02l7.3-13.62v-.1l65.45-124.46,4.75,2.44c1.31,.67,2.83-.41,2.62-1.86l-1.58-11.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M507.91,112.85l-1.79-12.04c-.18-1.23-1.53-1.92-2.63-1.33l-10.77,5.68-9.93,5.24c-1.3,.69-1.28,2.55,.03,3.22l4.42,2.24-78.53,152.35c-.42,.81-.41,1.76,.01,2.57l6.44,12.24c1.05,1.99,3.89,1.98,4.93-.02l82.4-159.41,4.47,2.26c1.31,.66,2.82-.43,2.61-1.88l-1.65-11.11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVruddhiVIcon);
export default __webpack_public_path__ + "static/media/vruddhi_v_icon.7029edf3572683248ae09f53d45fc639.svg";
export { ForwardRef as ReactComponent };